(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stock-48h-grid"] && !Shopify.designMode) return;
  try {
    
function initStock48(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
  const size = root.querySelector('[data-size]');
  const crystals = root.querySelector('[data-crystals]');
  const search = root.querySelector('[data-search]');
  const cards = [...root.querySelectorAll('[data-card]')].map(el => ({
    el, title: el.dataset.title.toLocaleLowerCase(), variants: JSON.parse(el.querySelector('[data-variants]').textContent)
  }));
  const sizes = [...new Set(cards.flatMap(card => card.variants.map(v => v.size)))].sort((a, b) => {
    const na = Number(a), nb = Number(b);
    return (Number.isNaN(na) ? 100 : na) - (Number.isNaN(nb) ? 100 : nb) || a.localeCompare(b);
  });
  sizes.forEach(value => size.add(new Option(value, value)));
  const params = new URLSearchParams(location.search);
  if (sizes.includes(params.get('talla'))) size.value = params.get('talla');
  if ([...crystals.options].some(o => o.value === params.get('cristales'))) crystals.value = params.get('cristales');
  search.value = params.get('modelo') || '';
  const money = new Intl.NumberFormat(root.dataset.locale || 'es', { style: 'currency', currency: root.dataset.currency || 'EUR' });
  function update(changeUrl) {
    const term = search.value.trim().toLocaleLowerCase();
    let count = 0;
    cards.forEach(card => {
      const matches = card.variants.filter(v => (!size.value || v.size === size.value) && (!crystals.value || v.crystals === crystals.value));
      const visible = card.title.includes(term) && matches.length > 0;
      card.el.hidden = !visible;
      if (!visible) return;
      count++;
      const prices = matches.map(v => v.price);
      const min = Math.min(...prices), max = Math.max(...prices);
      card.el.querySelector('[data-price]').textContent = (min !== max ? labels.from + ' ' : '') + money.format(min / 100);
      card.el.querySelector('[data-sizes]').textContent = sizes.filter(s => matches.some(v => v.size === s)).join(' · ');
      card.el.querySelector('[data-units]').textContent = matches.reduce((total, v) => total + v.quantity, 0) + ' ' + labels.units;
      const first = matches[0];
      card.el.querySelectorAll('[data-product-link]').forEach(a => { a.href = first.url + '?variant=' + first.id; });
    });
    root.querySelector('[data-count]').textContent = count + ' ' + labels.models;
    root.querySelector('[data-empty]').hidden = count !== 0;
    if (changeUrl) {
      const url = new URL(location.href);
      [['talla', size.value], ['cristales', crystals.value], ['modelo', search.value.trim()]].forEach(([k, v]) => v ? url.searchParams.set(k, v) : url.searchParams.delete(k));
      history.replaceState(null, '', url);
    }
  }
  size.addEventListener('change', () => update(true));
  crystals.addEventListener('change', () => update(true));
  search.addEventListener('input', () => update(true));
  root.querySelector('[data-reset]').addEventListener('click', () => { size.value = ''; crystals.value = ''; search.value = ''; update(true); });
  update(false);
}
document.querySelectorAll('[data-stock48]').forEach(initStock48);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-stock48]').forEach(initStock48));

  } catch(e) { console.error(e); }
})();
})();
